import { RvqPreferenceType } from "../Constants/RvqPreferenceType";

export abstract class BaseRvqPreference {
    public ItemId: number;
    public DisplayName: string;
    public PreferenceId: string;
    public EntityId: string;
    public EmployeeId: string;
    public IsFavorite: boolean = false;
    public IsPinned: boolean = false;
    public LastAppliedDate: Date;
    public Type: RvqPreferenceType;

    public constructor(init?: Partial<BaseRvqPreference>) {
        Object.assign(this, init);
        this.ItemId = sessionStore.newId();
    }

    /**
     * A comparable identifier for the RVQ entity. For example, the practitioner ID for a practitioner preference, or the medication + lot ID for a medication preference.
     */
    public abstract get comparableRvqId(): string;
}
